/**
 * Picks v2 or v1 of the Daily Inspiration edit form based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import DailyReflectionForm     from './DailyReflectionForm';
import DailyReflectionFormPageV2 from './DailyReflectionFormPageV2';

export default function DailyReflectionFormSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? DailyReflectionFormPageV2 : DailyReflectionForm;
  return <Component {...props} />;
}
